import React, { Fragment, useState, useEffect, useContext } from'react';
import axios from 'axios';
import { useAlert } from 'react-alert';

import context from '../../../../../../../context/auth-context';
import errorHandler from '../../../../../../../hoc/ErrorHandler';
import Spinner from '../../../../../../UI/Spinner/Spinner';
import Overflow from '../../../../../../UI/Overflow/Overflow';
import { IS_EMPTY } from '../../../../../../../constants';
import UserTasksAccordion from './Accordions/UserTasks';
import ExternalUserTasksAccordion from './Accordions/ExternalTasks';
import Error from './Error/Error';
import Empty from './Empty/Empty';

const Reminders = props => {

    const [userTasks, setUserTasks] = useState(null);
    const [userTasksLoading, setUserTasksLoading] = useState(true);
    const [userTasksError, setUserTasksError] = useState(false);
    const [externalUserTasks, setExternalUserTasks] = useState(null);
    const [externalUserTasksLoading, setExternalUserTasksLoading] = useState(true);
    const [externalUserTasksError, setExternalUserTasksError] = useState(false);

    const authContext = useContext(context);
    const alert = useAlert();

    useEffect(() => {
        if(authContext.tokenIsValid){
        const getUserPendingTasks = async () => {
            const userTasks = await axios.get(`/users/${authContext.userId}/tasks/pending`, {headers: {
                'Company-Code': authContext.companyCode,
                'Company-Id': authContext.companyId
            }});
            if(userTasks) {
                setUserTasksLoading(false);
                setUserTasksError(false)
                return setUserTasks(userTasks.data);
            }else {
                setUserTasksLoading(false);
                return setUserTasksError(true);
            }
        };

        const getExternalUserPendingTasks = async () => {
            const externalUserTasks = await axios.get('/users/external/tasks/pending', {headers: {
                'Company-Code': authContext.companyCode,
                'Company-Id': authContext.companyId
            }});

            if(externalUserTasks) {
                setExternalUserTasksLoading(false);
                setExternalUserTasksError(false)
                return setExternalUserTasks(externalUserTasks.data);
            }else {
                setExternalUserTasksLoading(false);
                return setExternalUserTasksError(true);
            }
        };

        getUserPendingTasks();
        getExternalUserPendingTasks();
        }
        return () => {
            setUserTasksLoading(true);
            setExternalUserTasksLoading(true);
            setUserTasks(null);
            setExternalUserTasks(null);
            if(userTasksError) setUserTasksError(false);
            if(externalUserTasksError) setExternalUserTasksError(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authContext.companyId, authContext.tokenIsValid]);

    const taskNameShortener = name => name.length > 30 ? name.substring(0, 30).concat('...') : name;

    const taskActionHandler = async (task_id, action_data, task_category) => {
        const response = await axios.patch('/users/tasks', {id: task_id, ...action_data}, {headers: {
            Authorization: authContext.accessToken,
            'Company-Code': authContext.companyCode,
            'Company-Id': authContext.companyId
        }});

        if(response) {
            const _userTasks = Object.assign([], userTasks);
            const _externalUserTasks = Object.assign([], externalUserTasks);

            if(action_data.completed) {
                switch(task_category) {
                    case 'external': {
                        const index = _externalUserTasks.findIndex(task => parseInt(task.id) === parseInt(task_id));
                        _externalUserTasks.splice(index, 1);
                        setExternalUserTasks(_externalUserTasks);
                    }
                    break;
                    default: {
                        const index = _userTasks.findIndex(task => parseInt(task.id) === parseInt(task_id));
                        _userTasks.splice(index, 1);
                        setUserTasks(_userTasks);
                    }
                }
            }

            return alert.show('Action recorded', {type: 'success'});
        }
    };

    return(
        <Fragment>
            <div className="col-md-3">
                <h5 className="mb-0">Your pending tasks</h5>
                <Overflow maxHeight="450px">
                    <div className="panel-group panel-group-simple" id="taskAccordion" aria-multiselectable="true" role="tablist">
                        {!userTasksLoading ? (!userTasksError ? !IS_EMPTY(userTasks) ? <UserTasksAccordion tasks={userTasks} taskNameShortener={taskNameShortener} taskActionHandler={taskActionHandler} /> : <Empty /> : <Error />) : <Spinner />}
                    </div>
                </Overflow>
            </div>
            <div className="col-md-3">
                <h5 className="mb-0">External user pending tasks</h5>
                <Overflow maxHeight="450px">
                    <div className="panel-group panel-group-simple" id="taskAccordion" aria-multiselectable="true" role="tablist">
                        {!externalUserTasksLoading ? (!externalUserTasksError ? !IS_EMPTY(externalUserTasks) ? <ExternalUserTasksAccordion tasks={externalUserTasks} taskNameShortener={taskNameShortener} taskActionHandler={taskActionHandler} /> : <Empty /> : <Error />) : <Spinner />}
                    </div>
                </Overflow>
            </div>
        </Fragment>
    );
};

export default errorHandler(Reminders, axios);